import { cn } from "@/lib/utils";
import { isHttpUrl, tableCellToParts } from "@/lib/utils/aiTableUtils";

export interface ChatLinkableTextProps {
  /**
   * Plain string, text with markdown `[label](url)` links, `{ text, url }`
   * link object, or an array of these (joined with ", ").
   */
  value: unknown;
  className?: string;
}

/**
 * Renders Herald cell-like values as plain text with external links for any
 * markdown links or `{ text, url }` objects they contain.
 */
const ChatLinkableText = ({ value, className }: ChatLinkableTextProps) => {
  const parts = tableCellToParts(value);
  const [onlyPart] = parts;

  if (
    parts.length === 1 &&
    typeof onlyPart === "object" &&
    isHttpUrl(onlyPart.url)
  ) {
    return (
      <a
        href={onlyPart.url}
        target="_blank"
        rel="noopener noreferrer"
        className={cn(className, "text-primary underline")}
      >
        {onlyPart.text}
      </a>
    );
  }

  return (
    <span className={className}>
      {parts.map((part, i) => {
        if (typeof part === "string") return part;
        if (!isHttpUrl(part.url)) return part.text;
        return (
          <a
            // biome-ignore lint/suspicious/noArrayIndexKey: parts are in stable order; key needed for React list
            key={i}
            href={part.url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary underline"
          >
            {part.text}
          </a>
        );
      })}
    </span>
  );
};

export default ChatLinkableText;
